<template>
  <div class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" id="putAwayModal">
    <div class="modal-dialog  modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header header-dark">
          <h5 class="modal-title">Put Away Inbound {{ order.number }}</h5>
        </div>
        <div class="modal-body p-0" id="put-away">
          <table class="table table-hover border-bottom mb-0">
            <thead class="thead-light">
              <th>SKU</th>
              <th>Description</th>
              <th>Carton</th>
              <th>Location</th>
            </thead>
            <tbody v-if="showCartons" >
              <tr v-for="carton in order.cartons" :key="carton.id">
                <td>{{ carton.item.product.customer_sku }}</td>
                <td>{{ carton.item.product.name }}</td>
                <td>{{ carton.id }}</td>
                <td style="width: 300px;">
                  <vue-select
                    v-model="carton.bin"
                    :options="bins"
                    label="name"
                  ></vue-select>
                </td>
              </tr>
              <tr v-if="order.items.length == 0">
                <td colspan="4" class="text-center">No items for this order</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center">
                  <i class="fa fa-spinner fa-spin"></i>
                  Loading Cartons
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">      
          <div class="alert alert-danger" v-if="!valid">
            All fields are required!
          </div>            
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button :disabled="!valid || submited" type="button" class="btn btn-primary" @click="submit">
            <i class="fa fa-check"></i> Put Away
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import userStore from '@/stores/users'
import binStore from '@/stores/bins'

import bin from '@/libs/bin'
import user from '@/libs/user'

export default {
  name: 'put-away-modal',
  components: { VueSelect },
  props: { order: Object },

  data() {
    return {
      showCartons: false,
      submited: false
    }
  },

  created() {
    this.fetchData()
  },

  mounted() {
    setTimeout(() => {
      this.showCartons = true
    }, 500)
  },

  computed: {
    bins() {
      return binStore.state.bins
    },

    users() {
      return userStore.state.users
    },

    valid() {
      let valid = true
      this.order.cartons.forEach(c => {
        if (!c.bin || !c.bin.id) {
          valid = false
        }
      })

      return valid
    }
  },

  methods: {
    submit() {
      if (this.valid) {
        this.submited = true
        this.$emit('put-away-order')
      }
    },

    fetchData() {
      bin.all().then(res => {
        binStore.setBins(res.data.bins)
      })

      user.all().then(res => {
        userStore.setUsers(res.data.users)
      })
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>